/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MediaBaseService } from '../media-base-service';
import { MediaApiConfiguration } from '../media-api-configuration';
import { MediaStrictHttpResponse } from '../media-strict-http-response';

import { articleArticleTypesGet$Json } from '../fn/article/article-article-types-get-json';
import { ArticleArticleTypesGet$Json$Params } from '../fn/article/article-article-types-get-json';
import { articleArticleTypesGet$Plain } from '../fn/article/article-article-types-get-plain';
import { ArticleArticleTypesGet$Plain$Params } from '../fn/article/article-article-types-get-plain';
import { articleClientsGet$Json } from '../fn/article/article-clients-get-json';
import { ArticleClientsGet$Json$Params } from '../fn/article/article-clients-get-json';
import { articleClientsGet$Plain } from '../fn/article/article-clients-get-plain';
import { ArticleClientsGet$Plain$Params } from '../fn/article/article-clients-get-plain';
import { ArticleDetailModel } from '../models/article-detail-model';
import { ArticleGetResponseModel } from '../models/article-get-response-model';
import { articlePublisherIdApproveIdPost$Json } from '../fn/article/article-publisher-id-approve-id-post-json';
import { ArticlePublisherIdApproveIdPost$Json$Params } from '../fn/article/article-publisher-id-approve-id-post-json';
import { articlePublisherIdApproveIdPost$Plain } from '../fn/article/article-publisher-id-approve-id-post-plain';
import { ArticlePublisherIdApproveIdPost$Plain$Params } from '../fn/article/article-publisher-id-approve-id-post-plain';
import { articlePublisherIdIdAudioLanguageIdGet } from '../fn/article/article-publisher-id-id-audio-language-id-get';
import { ArticlePublisherIdIdAudioLanguageIdGet$Params } from '../fn/article/article-publisher-id-id-audio-language-id-get';
import { articlePublisherIdIdAudioLanguageIdPost$Json } from '../fn/article/article-publisher-id-id-audio-language-id-post-json';
import { ArticlePublisherIdIdAudioLanguageIdPost$Json$Params } from '../fn/article/article-publisher-id-id-audio-language-id-post-json';
import { articlePublisherIdIdAudioLanguageIdPost$Plain } from '../fn/article/article-publisher-id-id-audio-language-id-post-plain';
import { ArticlePublisherIdIdAudioLanguageIdPost$Plain$Params } from '../fn/article/article-publisher-id-id-audio-language-id-post-plain';
import { articlePublisherIdIdGet$Json } from '../fn/article/article-publisher-id-id-get-json';
import { ArticlePublisherIdIdGet$Json$Params } from '../fn/article/article-publisher-id-id-get-json';
import { articlePublisherIdIdGet$Plain } from '../fn/article/article-publisher-id-id-get-plain';
import { ArticlePublisherIdIdGet$Plain$Params } from '../fn/article/article-publisher-id-id-get-plain';
import { articlePublisherIdIdHtmlArticleLanguageIdGet$Json } from '../fn/article/article-publisher-id-id-html-article-language-id-get-json';
import { ArticlePublisherIdIdHtmlArticleLanguageIdGet$Json$Params } from '../fn/article/article-publisher-id-id-html-article-language-id-get-json';
import { articlePublisherIdIdHtmlArticleLanguageIdGet$Plain } from '../fn/article/article-publisher-id-id-html-article-language-id-get-plain';
import { ArticlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Params } from '../fn/article/article-publisher-id-id-html-article-language-id-get-plain';
import { articlePublisherIdIdHtmlArticleLanguageIdPost$Json } from '../fn/article/article-publisher-id-id-html-article-language-id-post-json';
import { ArticlePublisherIdIdHtmlArticleLanguageIdPost$Json$Params } from '../fn/article/article-publisher-id-id-html-article-language-id-post-json';
import { articlePublisherIdIdHtmlArticleLanguageIdPost$Plain } from '../fn/article/article-publisher-id-id-html-article-language-id-post-plain';
import { ArticlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Params } from '../fn/article/article-publisher-id-id-html-article-language-id-post-plain';
import { articlePublisherIdIdInfoGraphicImageLanguageIdGet } from '../fn/article/article-publisher-id-id-info-graphic-image-language-id-get';
import { ArticlePublisherIdIdInfoGraphicImageLanguageIdGet$Params } from '../fn/article/article-publisher-id-id-info-graphic-image-language-id-get';
import { articlePublisherIdIdInfoGraphicLanguageIdGet$Json } from '../fn/article/article-publisher-id-id-info-graphic-language-id-get-json';
import { ArticlePublisherIdIdInfoGraphicLanguageIdGet$Json$Params } from '../fn/article/article-publisher-id-id-info-graphic-language-id-get-json';
import { articlePublisherIdIdInfoGraphicLanguageIdGet$Plain } from '../fn/article/article-publisher-id-id-info-graphic-language-id-get-plain';
import { ArticlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Params } from '../fn/article/article-publisher-id-id-info-graphic-language-id-get-plain';
import { articlePublisherIdIdInfoGraphicLanguageIdPost$Json } from '../fn/article/article-publisher-id-id-info-graphic-language-id-post-json';
import { ArticlePublisherIdIdInfoGraphicLanguageIdPost$Json$Params } from '../fn/article/article-publisher-id-id-info-graphic-language-id-post-json';
import { articlePublisherIdIdInfoGraphicLanguageIdPost$Plain } from '../fn/article/article-publisher-id-id-info-graphic-language-id-post-plain';
import { ArticlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Params } from '../fn/article/article-publisher-id-id-info-graphic-language-id-post-plain';
import { articlePublisherIdIdPreviewLanguageIdGet } from '../fn/article/article-publisher-id-id-preview-language-id-get';
import { ArticlePublisherIdIdPreviewLanguageIdGet$Params } from '../fn/article/article-publisher-id-id-preview-language-id-get';
import { articlePublisherIdIdRelationalTagLanguageIdGet$Json } from '../fn/article/article-publisher-id-id-relational-tag-language-id-get-json';
import { ArticlePublisherIdIdRelationalTagLanguageIdGet$Json$Params } from '../fn/article/article-publisher-id-id-relational-tag-language-id-get-json';
import { articlePublisherIdIdRelationalTagLanguageIdGet$Plain } from '../fn/article/article-publisher-id-id-relational-tag-language-id-get-plain';
import { ArticlePublisherIdIdRelationalTagLanguageIdGet$Plain$Params } from '../fn/article/article-publisher-id-id-relational-tag-language-id-get-plain';
import { articlePublisherIdIdRelationalTagLanguageIdKeyDelete } from '../fn/article/article-publisher-id-id-relational-tag-language-id-key-delete';
import { ArticlePublisherIdIdRelationalTagLanguageIdKeyDelete$Params } from '../fn/article/article-publisher-id-id-relational-tag-language-id-key-delete';
import { articlePublisherIdIdRelationalTagLanguageIdPost } from '../fn/article/article-publisher-id-id-relational-tag-language-id-post';
import { ArticlePublisherIdIdRelationalTagLanguageIdPost$Params } from '../fn/article/article-publisher-id-id-relational-tag-language-id-post';
import { articlePublisherIdIdTextToSpeechLanguageIdPost$Json } from '../fn/article/article-publisher-id-id-text-to-speech-language-id-post-json';
import { ArticlePublisherIdIdTextToSpeechLanguageIdPost$Json$Params } from '../fn/article/article-publisher-id-id-text-to-speech-language-id-post-json';
import { articlePublisherIdIdTextToSpeechLanguageIdPost$Plain } from '../fn/article/article-publisher-id-id-text-to-speech-language-id-post-plain';
import { ArticlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Params } from '../fn/article/article-publisher-id-id-text-to-speech-language-id-post-plain';
import { articlePublisherIdIdTranslateLanguageIdPost$Json } from '../fn/article/article-publisher-id-id-translate-language-id-post-json';
import { ArticlePublisherIdIdTranslateLanguageIdPost$Json$Params } from '../fn/article/article-publisher-id-id-translate-language-id-post-json';
import { articlePublisherIdIdTranslateLanguageIdPost$Plain } from '../fn/article/article-publisher-id-id-translate-language-id-post-plain';
import { ArticlePublisherIdIdTranslateLanguageIdPost$Plain$Params } from '../fn/article/article-publisher-id-id-translate-language-id-post-plain';
import { articlePublisherIdPost$Json } from '../fn/article/article-publisher-id-post-json';
import { ArticlePublisherIdPost$Json$Params } from '../fn/article/article-publisher-id-post-json';
import { articlePublisherIdPost$Plain } from '../fn/article/article-publisher-id-post-plain';
import { ArticlePublisherIdPost$Plain$Params } from '../fn/article/article-publisher-id-post-plain';
import { ArticleRelationalTagModel } from '../models/article-relational-tag-model';
import { articleSearchArticlePublisherIdPost$Json } from '../fn/article/article-search-article-publisher-id-post-json';
import { ArticleSearchArticlePublisherIdPost$Json$Params } from '../fn/article/article-search-article-publisher-id-post-json';
import { articleSearchArticlePublisherIdPost$Plain } from '../fn/article/article-search-article-publisher-id-post-plain';
import { ArticleSearchArticlePublisherIdPost$Plain$Params } from '../fn/article/article-search-article-publisher-id-post-plain';
import { ArticleSearchResultModelSearchResultModel } from '../models/article-search-result-model-search-result-model';
import { articleStatusTypesGet$Json } from '../fn/article/article-status-types-get-json';
import { ArticleStatusTypesGet$Json$Params } from '../fn/article/article-status-types-get-json';
import { articleStatusTypesGet$Plain } from '../fn/article/article-status-types-get-plain';
import { ArticleStatusTypesGet$Plain$Params } from '../fn/article/article-status-types-get-plain';
import { articleViewClientIdShortCodeLanguageCodeGet } from '../fn/article/article-view-client-id-short-code-language-code-get';
import { ArticleViewClientIdShortCodeLanguageCodeGet$Params } from '../fn/article/article-view-client-id-short-code-language-code-get';
import { InfoGraphicModel } from '../models/info-graphic-model';
import { KeyValueGuidModel } from '../models/key-value-guid-model';
import { KeyValueModel } from '../models/key-value-model';

@Injectable({ providedIn: 'root' })
export class MediaArticleService extends MediaBaseService {
  constructor(config: MediaApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `articleSearchArticlePublisherIdPost()` */
  static readonly ArticleSearchArticlePublisherIdPostPath = '/Article/SearchArticle/{publisherId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleSearchArticlePublisherIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articleSearchArticlePublisherIdPost$Plain$Response(params: ArticleSearchArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>> {
    return articleSearchArticlePublisherIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleSearchArticlePublisherIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articleSearchArticlePublisherIdPost$Plain(params: ArticleSearchArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<ArticleSearchResultModelSearchResultModel> {
    return this.articleSearchArticlePublisherIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>): ArticleSearchResultModelSearchResultModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleSearchArticlePublisherIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articleSearchArticlePublisherIdPost$Json$Response(params: ArticleSearchArticlePublisherIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>> {
    return articleSearchArticlePublisherIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleSearchArticlePublisherIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articleSearchArticlePublisherIdPost$Json(params: ArticleSearchArticlePublisherIdPost$Json$Params, context?: HttpContext): Observable<ArticleSearchResultModelSearchResultModel> {
    return this.articleSearchArticlePublisherIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleSearchResultModelSearchResultModel>): ArticleSearchResultModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdGet()` */
  static readonly ArticlePublisherIdIdGetPath = '/Article/{publisherId}/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdGet$Plain$Response(params: ArticlePublisherIdIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleGetResponseModel>> {
    return articlePublisherIdIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdGet$Plain(params: ArticlePublisherIdIdGet$Plain$Params, context?: HttpContext): Observable<ArticleGetResponseModel> {
    return this.articlePublisherIdIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleGetResponseModel>): ArticleGetResponseModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdGet$Json$Response(params: ArticlePublisherIdIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleGetResponseModel>> {
    return articlePublisherIdIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdGet$Json(params: ArticlePublisherIdIdGet$Json$Params, context?: HttpContext): Observable<ArticleGetResponseModel> {
    return this.articlePublisherIdIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleGetResponseModel>): ArticleGetResponseModel => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdPost()` */
  static readonly ArticlePublisherIdPostPath = '/Article/{publisherId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdPost$Plain$Response(params: ArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdPost$Plain(params: ArticlePublisherIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdPost$Json$Response(params: ArticlePublisherIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdPost$Json(params: ArticlePublisherIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdApproveIdPost()` */
  static readonly ArticlePublisherIdApproveIdPostPath = '/Article/{publisherId}/Approve/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdApproveIdPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdApproveIdPost$Plain$Response(params: ArticlePublisherIdApproveIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdApproveIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdApproveIdPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdApproveIdPost$Plain(params: ArticlePublisherIdApproveIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdApproveIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdApproveIdPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdApproveIdPost$Json$Response(params: ArticlePublisherIdApproveIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdApproveIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdApproveIdPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdApproveIdPost$Json(params: ArticlePublisherIdApproveIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdApproveIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdHtmlArticleLanguageIdGet()` */
  static readonly ArticlePublisherIdIdHtmlArticleLanguageIdGetPath = '/Article/{publisherId}/{id}/HtmlArticle/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdHtmlArticleLanguageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Response(params: ArticlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleDetailModel>> {
    return articlePublisherIdIdHtmlArticleLanguageIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdHtmlArticleLanguageIdGet$Plain(params: ArticlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Params, context?: HttpContext): Observable<ArticleDetailModel> {
    return this.articlePublisherIdIdHtmlArticleLanguageIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleDetailModel>): ArticleDetailModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdHtmlArticleLanguageIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdHtmlArticleLanguageIdGet$Json$Response(params: ArticlePublisherIdIdHtmlArticleLanguageIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<ArticleDetailModel>> {
    return articlePublisherIdIdHtmlArticleLanguageIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdHtmlArticleLanguageIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdHtmlArticleLanguageIdGet$Json(params: ArticlePublisherIdIdHtmlArticleLanguageIdGet$Json$Params, context?: HttpContext): Observable<ArticleDetailModel> {
    return this.articlePublisherIdIdHtmlArticleLanguageIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<ArticleDetailModel>): ArticleDetailModel => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdHtmlArticleLanguageIdPost()` */
  static readonly ArticlePublisherIdIdHtmlArticleLanguageIdPostPath = '/Article/{publisherId}/{id}/HtmlArticle/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdHtmlArticleLanguageIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Response(params: ArticlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdHtmlArticleLanguageIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdHtmlArticleLanguageIdPost$Plain(params: ArticlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdHtmlArticleLanguageIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdHtmlArticleLanguageIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdHtmlArticleLanguageIdPost$Json$Response(params: ArticlePublisherIdIdHtmlArticleLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdHtmlArticleLanguageIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdHtmlArticleLanguageIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdHtmlArticleLanguageIdPost$Json(params: ArticlePublisherIdIdHtmlArticleLanguageIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdHtmlArticleLanguageIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdInfoGraphicLanguageIdGet()` */
  static readonly ArticlePublisherIdIdInfoGraphicLanguageIdGetPath = '/Article/{publisherId}/{id}/InfoGraphic/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdInfoGraphicLanguageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Response(params: ArticlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<InfoGraphicModel>> {
    return articlePublisherIdIdInfoGraphicLanguageIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicLanguageIdGet$Plain(params: ArticlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Params, context?: HttpContext): Observable<InfoGraphicModel> {
    return this.articlePublisherIdIdInfoGraphicLanguageIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<InfoGraphicModel>): InfoGraphicModel => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdInfoGraphicLanguageIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicLanguageIdGet$Json$Response(params: ArticlePublisherIdIdInfoGraphicLanguageIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<InfoGraphicModel>> {
    return articlePublisherIdIdInfoGraphicLanguageIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdInfoGraphicLanguageIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicLanguageIdGet$Json(params: ArticlePublisherIdIdInfoGraphicLanguageIdGet$Json$Params, context?: HttpContext): Observable<InfoGraphicModel> {
    return this.articlePublisherIdIdInfoGraphicLanguageIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<InfoGraphicModel>): InfoGraphicModel => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdInfoGraphicLanguageIdPost()` */
  static readonly ArticlePublisherIdIdInfoGraphicLanguageIdPostPath = '/Article/{publisherId}/{id}/InfoGraphic/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdInfoGraphicLanguageIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Response(params: ArticlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdInfoGraphicLanguageIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdInfoGraphicLanguageIdPost$Plain(params: ArticlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdInfoGraphicLanguageIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdInfoGraphicLanguageIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdInfoGraphicLanguageIdPost$Json$Response(params: ArticlePublisherIdIdInfoGraphicLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdInfoGraphicLanguageIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdInfoGraphicLanguageIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdInfoGraphicLanguageIdPost$Json(params: ArticlePublisherIdIdInfoGraphicLanguageIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdInfoGraphicLanguageIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdInfoGraphicImageLanguageIdGet()` */
  static readonly ArticlePublisherIdIdInfoGraphicImageLanguageIdGetPath = '/Article/{publisherId}/{id}/InfoGraphicImage/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdInfoGraphicImageLanguageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicImageLanguageIdGet$Response(params: ArticlePublisherIdIdInfoGraphicImageLanguageIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articlePublisherIdIdInfoGraphicImageLanguageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdInfoGraphicImageLanguageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdInfoGraphicImageLanguageIdGet(params: ArticlePublisherIdIdInfoGraphicImageLanguageIdGet$Params, context?: HttpContext): Observable<void> {
    return this.articlePublisherIdIdInfoGraphicImageLanguageIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdAudioLanguageIdGet()` */
  static readonly ArticlePublisherIdIdAudioLanguageIdGetPath = '/Article/{publisherId}/{id}/Audio/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdAudioLanguageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdAudioLanguageIdGet$Response(params: ArticlePublisherIdIdAudioLanguageIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articlePublisherIdIdAudioLanguageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdAudioLanguageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdAudioLanguageIdGet(params: ArticlePublisherIdIdAudioLanguageIdGet$Params, context?: HttpContext): Observable<void> {
    return this.articlePublisherIdIdAudioLanguageIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdAudioLanguageIdPost()` */
  static readonly ArticlePublisherIdIdAudioLanguageIdPostPath = '/Article/{publisherId}/{id}/Audio/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdAudioLanguageIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdAudioLanguageIdPost$Plain$Response(params: ArticlePublisherIdIdAudioLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdAudioLanguageIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdAudioLanguageIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdAudioLanguageIdPost$Plain(params: ArticlePublisherIdIdAudioLanguageIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdAudioLanguageIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdAudioLanguageIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdAudioLanguageIdPost$Json$Response(params: ArticlePublisherIdIdAudioLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdAudioLanguageIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdAudioLanguageIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdAudioLanguageIdPost$Json(params: ArticlePublisherIdIdAudioLanguageIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdAudioLanguageIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdRelationalTagLanguageIdGet()` */
  static readonly ArticlePublisherIdIdRelationalTagLanguageIdGetPath = '/Article/{publisherId}/{id}/RelationalTag/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdRelationalTagLanguageIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdGet$Plain$Response(params: ArticlePublisherIdIdRelationalTagLanguageIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>> {
    return articlePublisherIdIdRelationalTagLanguageIdGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdRelationalTagLanguageIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdGet$Plain(params: ArticlePublisherIdIdRelationalTagLanguageIdGet$Plain$Params, context?: HttpContext): Observable<Array<ArticleRelationalTagModel>> {
    return this.articlePublisherIdIdRelationalTagLanguageIdGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>): Array<ArticleRelationalTagModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdRelationalTagLanguageIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdGet$Json$Response(params: ArticlePublisherIdIdRelationalTagLanguageIdGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>> {
    return articlePublisherIdIdRelationalTagLanguageIdGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdRelationalTagLanguageIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdGet$Json(params: ArticlePublisherIdIdRelationalTagLanguageIdGet$Json$Params, context?: HttpContext): Observable<Array<ArticleRelationalTagModel>> {
    return this.articlePublisherIdIdRelationalTagLanguageIdGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<ArticleRelationalTagModel>>): Array<ArticleRelationalTagModel> => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdRelationalTagLanguageIdPost()` */
  static readonly ArticlePublisherIdIdRelationalTagLanguageIdPostPath = '/Article/{publisherId}/{id}/RelationalTag/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdRelationalTagLanguageIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdRelationalTagLanguageIdPost$Response(params: ArticlePublisherIdIdRelationalTagLanguageIdPost$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articlePublisherIdIdRelationalTagLanguageIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdRelationalTagLanguageIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdRelationalTagLanguageIdPost(params: ArticlePublisherIdIdRelationalTagLanguageIdPost$Params, context?: HttpContext): Observable<void> {
    return this.articlePublisherIdIdRelationalTagLanguageIdPost$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdRelationalTagLanguageIdKeyDelete()` */
  static readonly ArticlePublisherIdIdRelationalTagLanguageIdKeyDeletePath = '/Article/{publisherId}/{id}/RelationalTag/{languageId}/{key}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdRelationalTagLanguageIdKeyDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdKeyDelete$Response(params: ArticlePublisherIdIdRelationalTagLanguageIdKeyDelete$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articlePublisherIdIdRelationalTagLanguageIdKeyDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdRelationalTagLanguageIdKeyDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdRelationalTagLanguageIdKeyDelete(params: ArticlePublisherIdIdRelationalTagLanguageIdKeyDelete$Params, context?: HttpContext): Observable<void> {
    return this.articlePublisherIdIdRelationalTagLanguageIdKeyDelete$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdTranslateLanguageIdPost()` */
  static readonly ArticlePublisherIdIdTranslateLanguageIdPostPath = '/Article/{publisherId}/{id}/Translate/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdTranslateLanguageIdPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdTranslateLanguageIdPost$Plain$Response(params: ArticlePublisherIdIdTranslateLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdTranslateLanguageIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdTranslateLanguageIdPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdTranslateLanguageIdPost$Plain(params: ArticlePublisherIdIdTranslateLanguageIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdTranslateLanguageIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdTranslateLanguageIdPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdTranslateLanguageIdPost$Json$Response(params: ArticlePublisherIdIdTranslateLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdTranslateLanguageIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdTranslateLanguageIdPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  articlePublisherIdIdTranslateLanguageIdPost$Json(params: ArticlePublisherIdIdTranslateLanguageIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdTranslateLanguageIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdTextToSpeechLanguageIdPost()` */
  static readonly ArticlePublisherIdIdTextToSpeechLanguageIdPostPath = '/Article/{publisherId}/{id}/TextToSpeech/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdTextToSpeechLanguageIdPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Response(params: ArticlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdTextToSpeechLanguageIdPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdTextToSpeechLanguageIdPost$Plain(params: ArticlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdTextToSpeechLanguageIdPost$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdTextToSpeechLanguageIdPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdTextToSpeechLanguageIdPost$Json$Response(params: ArticlePublisherIdIdTextToSpeechLanguageIdPost$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<string>> {
    return articlePublisherIdIdTextToSpeechLanguageIdPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdTextToSpeechLanguageIdPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdTextToSpeechLanguageIdPost$Json(params: ArticlePublisherIdIdTextToSpeechLanguageIdPost$Json$Params, context?: HttpContext): Observable<string> {
    return this.articlePublisherIdIdTextToSpeechLanguageIdPost$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `articleViewClientIdShortCodeLanguageCodeGet()` */
  static readonly ArticleViewClientIdShortCodeLanguageCodeGetPath = '/Article/View/{clientId}/{shortCode}/{languageCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleViewClientIdShortCodeLanguageCodeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleViewClientIdShortCodeLanguageCodeGet$Response(params: ArticleViewClientIdShortCodeLanguageCodeGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articleViewClientIdShortCodeLanguageCodeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleViewClientIdShortCodeLanguageCodeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleViewClientIdShortCodeLanguageCodeGet(params: ArticleViewClientIdShortCodeLanguageCodeGet$Params, context?: HttpContext): Observable<void> {
    return this.articleViewClientIdShortCodeLanguageCodeGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articlePublisherIdIdPreviewLanguageIdGet()` */
  static readonly ArticlePublisherIdIdPreviewLanguageIdGetPath = '/Article/{publisherId}/{id}/Preview/{languageId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articlePublisherIdIdPreviewLanguageIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdPreviewLanguageIdGet$Response(params: ArticlePublisherIdIdPreviewLanguageIdGet$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<void>> {
    return articlePublisherIdIdPreviewLanguageIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articlePublisherIdIdPreviewLanguageIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articlePublisherIdIdPreviewLanguageIdGet(params: ArticlePublisherIdIdPreviewLanguageIdGet$Params, context?: HttpContext): Observable<void> {
    return this.articlePublisherIdIdPreviewLanguageIdGet$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `articleArticleTypesGet()` */
  static readonly ArticleArticleTypesGetPath = '/Article/ArticleTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleArticleTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleArticleTypesGet$Plain$Response(params?: ArticleArticleTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return articleArticleTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleArticleTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleArticleTypesGet$Plain(params?: ArticleArticleTypesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.articleArticleTypesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleArticleTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleArticleTypesGet$Json$Response(params?: ArticleArticleTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return articleArticleTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleArticleTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleArticleTypesGet$Json(params?: ArticleArticleTypesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.articleArticleTypesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `articleStatusTypesGet()` */
  static readonly ArticleStatusTypesGetPath = '/Article/StatusTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleStatusTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleStatusTypesGet$Plain$Response(params?: ArticleStatusTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return articleStatusTypesGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleStatusTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleStatusTypesGet$Plain(params?: ArticleStatusTypesGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.articleStatusTypesGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleStatusTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleStatusTypesGet$Json$Response(params?: ArticleStatusTypesGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
    return articleStatusTypesGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleStatusTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleStatusTypesGet$Json(params?: ArticleStatusTypesGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueModel>> {
    return this.articleStatusTypesGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueModel>>): Array<KeyValueModel> => r.body)
    );
  }

  /** Path part for operation `articleClientsGet()` */
  static readonly ArticleClientsGetPath = '/Article/Clients';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleClientsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleClientsGet$Plain$Response(params?: ArticleClientsGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return articleClientsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleClientsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleClientsGet$Plain(params?: ArticleClientsGet$Plain$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.articleClientsGet$Plain$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `articleClientsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleClientsGet$Json$Response(params?: ArticleClientsGet$Json$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueGuidModel>>> {
    return articleClientsGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `articleClientsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  articleClientsGet$Json(params?: ArticleClientsGet$Json$Params, context?: HttpContext): Observable<Array<KeyValueGuidModel>> {
    return this.articleClientsGet$Json$Response(params, context).pipe(
      map((r: MediaStrictHttpResponse<Array<KeyValueGuidModel>>): Array<KeyValueGuidModel> => r.body)
    );
  }

}
